import React, {useEffect} from 'react'
import './Suitscomng.css'
import Androidscreenshoot from '../images/Suitscomng/Androidscreenshoot.png'
import Artboard1 from '../images/Suitscomng/Artboard1.png'
import Artboard2 from '../images/Suitscomng/Artboard2.png'
import Artboard3 from '../images/Suitscomng/Artboard3.png'
import Artboard4 from '../images/Suitscomng/Artboard4.png'
import Artboard5 from '../images/Suitscomng/Artboard5.png'
import Artboard6 from '../images/Suitscomng/Artboard6.png'
import Artboard7 from '../images/Suitscomng/Artboard7.png'
import Artboard8 from '../images/Suitscomng/Artboard8.png'
import Artboard9 from '../images/Suitscomng/Artboard9.png'
import Artboard10 from '../images/Suitscomng/Artboard10.png'
import Footer from '../Component/footer'

function Suitscomng() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       

        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-suitscomng">
        <div className="client-role-suitscomng">
            <h4 className="client-project-suitscomng">CLIENT</h4>
            <h2 className="portfolio-heading-suitscomng1"> Suits.com.ng</h2>
            <h4 className="role-suitscomng">
            ROLE
            </h4>
            <h2 className="portfolio-role-suitscomng2"> UI/UX Designer</h2>
           </div>
            <h4 className="client-details-suitscomng"> DETAILS
            </h4>
            <p className="client-details-suitscomng-p">
              - Completed jobs 15% faster than targets on average.<br/>
              - Received 95% positive feedback from clients.<br/>
              - Spearheaded all design elements, templates and brand consistency.<br/>
              - Understand and work well with outputs from user and stakeholder research, being able to synthesize 
              insight to shape your design work and its outcomes.
            </p>

            <p className="client-details-suitscomng-p2">
            Our goal is to deliver superior suits and accessories, 
            to make you look classy and fashionable. We want to be known as the value leader
             in the fashion industry for dependable clothing at reasonable prices.
            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
       
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}

export default Suitscomng
